import { SchemaColumnOptions, SchemaTableOptions } from "@/vendors/prx-sqlite/Interfaces/SchemaInterfaces";
import defaultMigration from "../../defaultMigration";


export const intake_contact_numbers: SchemaTableOptions = {
   name:<string> 'intake_contact_numbers',
   schema:<Array<SchemaColumnOptions>> [
       { column: 'id', value: 'INTEGER PRIMARY KEY AUTOINCREMENT'},
       { column: 'cases_id', value: 'INTEGER UNSIGNED'}, 
       { column: 'label', value: 'VARCHAR(255) NOT NULL'}, 
       { column: 'number', value: 'VARCHAR(255) NOT NULL'}, 
       { column: 'encoded_by', value: 'INTEGER UNSIGNED'},
       ...defaultMigration
   ]
}
